/* eslint-disable react/jsx-props-no-spreading */
import { ErrorMessage } from '@hookform/error-message';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import { useTranslation } from 'react-i18next';
import { selectProductTaxes } from '../../../../../ducks/step4Module2';
import { FieldError } from '../../styles';
import { InputField } from '../form/fields';
import clearIcon from '../../../../../../assets/img/clear.svg';

const CouponContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  justify-content: ${({ isSticky }) => (isSticky ? 'flex-end' : 'space-between')};
`;

const ClearBtn = styled.button`
  position: absolute;
  bottom: 38px;
  right: 70px;
  text-align: center;
  width: 16px;
  height: 16px;
  font-weight: 600;
  border-radius: 50%;
  :hover {
    cursor: pointer;
  }
  padding: 0;
  color: transparent;
  transform: translateY(-2px);
  background-color: transparent;
  background-image: url(${clearIcon});
`;

const ValidateBtn = styled.button`
  font-weight: 600;
  color: ${getColor('primary')};
  :hover {
    cursor: pointer;
  }
  :disabled {
    cursor: unset;
    color: ${select('midLightGray')};
  }
`;

function CouponField({ onValidateCoupon = () => {} }) {
  const { discount } = useSelector(selectProductTaxes);
  const { getValues, setValue, clearErrors, watch, errors } = useFormContext();
  const { t } = useTranslation();

  const couponWatcher = watch('coupon');
  const disableValidate = !couponWatcher || couponWatcher.length < 5 || !!discount;

  const changeCouponFormat = () => {
    if (errors.coupon) {
      clearErrors('coupon');
    }
    const value = getValues('coupon');
    const formattedValue = value.replace(/[^a-z0-9]/gi, '');
    setValue('coupon', formattedValue);
  };

  const blurCouponFormat = () => {
    const value = getValues('coupon');
    const upperCaseValue = value.toUpperCase();
    setValue('coupon', upperCaseValue);
  };

  const onClear = () => {
    clearErrors('coupon');
    setValue('coupon', '');
  };

  return (
    <CouponContainer>
      <InputField
        name='coupon'
        small
        coupon
        maxLength='16'
        onBlur={blurCouponFormat}
        onChange={changeCouponFormat}
        renderError={errorProps => (
          <ErrorMessage {...errorProps} render={({ message }) => <FieldError>{message}</FieldError>} />
        )}
        disabled={!!discount}
      />
      {couponWatcher && !discount ? <ClearBtn onClick={onClear}>x</ClearBtn> : null}
      <ValidateBtn type='button' disabled={disableValidate} onClick={onValidateCoupon}>
        {t('publisher.step4.module2.field.coupon.validate')}
      </ValidateBtn>
    </CouponContainer>
  );
}

export default CouponField;
